/* suē Sweat B v2. Source-exact progress/light curves, Horizon scroll-container aware. */
(()=>{
 const track=document.getElementById('sue-sweat-hero');if(!track)return;
 const cueButton=track.querySelector('.sue-sweat-b__cue');
 const wrapper=document.querySelector('.page-wrapper');
 const clamp=x=>Math.max(0,Math.min(1,x));
 const smooth=(a,b,x)=>{let t=clamp((x-a)/(b-a));return t*t*(3-2*t)};
 const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
 function scrollHost(){
   return wrapper && wrapper.scrollHeight>wrapper.clientHeight+2 &&
     /auto|scroll/.test(getComputedStyle(wrapper).overflowY)?wrapper:window;
 }
 function state(){
   const host=scrollHost(),r=track.getBoundingClientRect();
   const viewportTop=host===window?0:wrapper.getBoundingClientRect().top;
   const viewportHeight=host===window?innerHeight:wrapper.clientHeight;
   const travel=Math.max(1,r.height-viewportHeight);
   return {host,r,viewportTop,travel};
 }
 let raf=0;
 function render(){
   raf=0;if(!track.isConnected)return;
   const {r,viewportTop,travel}=state();
   const p=clamp((viewportTop-r.top)/travel);
   const bloom=smooth(.05,.70,p),zoom=smooth(.14,.84,p);
   const scale=1+1.65*Math.pow(zoom,1.34);
   track.style.setProperty('--sue-b-zoom',scale.toFixed(4));
   track.style.setProperty('--sue-b-pan-x','0px');
   track.style.setProperty('--sue-b-pan-y','0px');
   const sun=(.82*bloom*(1-.18*smooth(.70,.90,p)));
   const silver=(.44*smooth(.14,.62,p)*(1-.26*smooth(.70,.90,p)));
   const shade=.20*smooth(.24,.66,p);
   track.style.setProperty('--sue-b-light1-opacity',sun.toFixed(3));
   track.style.setProperty('--sue-b-light2-opacity',silver.toFixed(3));
   track.style.setProperty('--sue-b-shade-opacity',shade.toFixed(3));
   track.style.setProperty('--sue-b-light1-x',(-76+104*bloom).toFixed(2)+'%');
   track.style.setProperty('--sue-b-light1-y',(10-14*bloom).toFixed(2)+'%');
   track.style.setProperty('--sue-b-light2-x',(24-56*smooth(.17,.74,p)).toFixed(2)+'%');
   track.style.setProperty('--sue-b-light2-y',(-12+14*smooth(.17,.74,p)).toFixed(2)+'%');
   track.style.setProperty('--sue-b-shade-x',(56-60*smooth(.18,.74,p)).toFixed(2)+'%');
   const blur=18*smooth(.70,.96,p);
   track.style.setProperty('--sue-b-blur',blur.toFixed(2)+'px');
   const fade=smooth(.83,.985,p),section=smooth(.89,.995,p);
   track.style.setProperty('--sue-b-whiteout',fade.toFixed(4));
   track.style.setProperty('--sue-b-ghost',section.toFixed(4));
   track.style.setProperty('--sue-b-cue-opacity',(1-smooth(.18,.34,p)).toFixed(4));
   track.style.setProperty('--sue-b-cue-y',(-10*smooth(.18,.34,p)).toFixed(2)+'px');
   if(cueButton){cueButton.style.pointerEvents=p>.34?'none':'auto';cueButton.tabIndex=p>.34?-1:0;}
 }
 function schedule(){if(!raf)raf=requestAnimationFrame(render)}
 function click(){
   const {host,r,viewportTop,travel}=state();
   const current=host===window?scrollY:host.scrollTop;
   const target=current+r.top-viewportTop+travel*.98;
   host.scrollTo({top:target,behavior:reduced?'auto':'smooth'});
 }
 cueButton?.addEventListener('click',click);
 window.addEventListener('scroll',schedule,{passive:true});
 wrapper?.addEventListener('scroll',schedule,{passive:true});
 window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',schedule);
 render();
})();